import { faHourglass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import styled from "styled-components";

const CountdownContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.time < 30 ?
    'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)' :
    props.time < 60 ?
      'linear-gradient(135deg, #ff9a44 0%, #fc6076 100%)' :
      'linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%)'
  };
  color: white;
  border-radius: 20px;
  padding: 6px 12px;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  font-family: 'Roboto Mono', monospace;
`;

const TimerIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
  animation: ${props => props.time < 30 ? 'pulse 1s infinite' : 'none'};
  
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      opacity: 0.7;
    }
    70% {
      transform: scale(1.1);
      opacity: 1;
    }
    100% {
      transform: scale(0.95);
      opacity: 0.7;
    }
  }
`;

const Countdown = (props) => {
  const [time, setTime] = useState(500); // 1000 seconds
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let timer;

    if (isActive && time > 0 && !props.isPaused) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      setIsActive(false);
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, [isActive, time, props.isPaused]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <CountdownContainer
      time={time}
      animate={{
        scale: time < 30 && time % 2 === 0 ? 1.05 : 1,
      }}
      transition={{ duration: 0.3 }}
    >
      <TimerIcon icon={faHourglass} time={time} /> {formatTime(time)}
    </CountdownContainer>
  );
};

export default Countdown;

